import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { changeUserPostal, changeUserToLocalStorage } from '../../services/user.service';
import { toast } from 'react-toastify';
import { toggleModal } from '../../redux/modal.slicer';
import ModalComponents from '../modal/Modal.Components';

const UserChangePostal = () => {
  const userStore = useSelector((state) => state.userStore.user); // Povlaci sacuvane podatke iz REDUX-a (folder redux)
  const [isLogged, setIsLogged] = useState(false);
  const [user, setUser] = useState(userStore);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (userStore) {
      setIsLogged(true);
    } else {
      navigate('/');
    }
  }, [navigate, userStore]);

  const handleChangeName = (e) => {
    let inputValue = e.target.value;
    let copyUser = { ...user, postal_code: inputValue };
    setUser(copyUser);
  };

  const onChangeSubmit = (e) => {
    e.preventDefault();
    if (!user.postal_code) {
      return toast.error('Polje ne sme biti prazno.');
    }
    if (user.postal_code.length < 5 || user.postal_code.length > 11) {
      return toast.error('Polje mora imati od 5 do 11 karaktera');
    }
    changeUserPostal({ user_id: user.user_id, postal_code: user.postal_code })
      .then((res) => {
        toast.success(res.data);
        changeUserToLocalStorage(user);
        navigate(`/user/${user.user_id}`);
        dispatch(toggleModal(false));
        window.location.reload();
      })
      .catch((err) => {
        toast.error(err.response.data);
      });
  };

  return (
    <ModalComponents>
      {isLogged && (
        <div className="col-12 col-sm-6 m-auto my-3 text-start">
          <form onSubmit={onChangeSubmit}>
            <div className="mb-3">
              <label htmlFor="postal_code" className="form-label">
                Promeni poštanski broj:
              </label>
              <input
                type="text"
                className="form-control"
                id="postal_code"
                aria-describedby="postal_code"
                placeholder="11000"
                defaultValue={userStore.postal_code}
                onChange={(e) => handleChangeName(e)}
              />
            </div>
            <button type="submit" className="btn btn-danger form-control">
              Izmeni
            </button>
          </form>
        </div>
      )}
    </ModalComponents>
  );
};

export default UserChangePostal;
